import type * as lazyFetchSearchFolderIdModule from "./utils/fetchSearchFolderIdFromServer";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyFetchSearchFolderIdModule> = new LazyModule<typeof lazyFetchSearchFolderIdModule>(() => import(
/* webpackChunkName: "FetchSearchFolderIdForBulkAction" */ "./utils/fetchSearchFolderIdFromServer"), { name: "FetchSearchFolderIdForBulkAction" });

export const lazyFetchSearchFolderIdFromServer: LazyAction<typeof lazyFetchSearchFolderIdModule.default, typeof lazyModule> = new LazyAction(lazyModule, m => m.default);
